import React from 'react'
import Prop from '../componentes/Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled from 'styled-components'
import { categorias } from '../listas/categorias'

const Galeria = () => {
    return (
        <>
            <Prop titulo='GALERIA' icono={ICON_TYPES.GALERIA} />
            <Section>
                {categorias.map(element => {
                    return (
                        <Tarjeta key={element.categoria}>
                            <img style={{ width: '100%', height: '400px', borderRadius: '20px', boxShadow: '4px 4px 10px #000', cursor: 'pointer' }} src={element.imagen} alt={element.titulo} />
                            <h3 style={{ textAlign: 'center', color: 'var(--primary)' }}>{element.categoria}</h3>
                        </Tarjeta>
                    )
                })}
            </Section>
        </>
    )
}

const Section = styled.section`
    width: 100vw;
    height: max-content;
    columns: 300px;
    margin: 20px 0;
`

const Tarjeta = styled.article`
    margin: auto;
    width: 300px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    & img:hover{
        transition: 1s ease all;
        scale: 1.03
    }
`

export default Galeria